<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="backWorklist">Back to Worklist</ion-button>
<!--          <ion-button class="btn-back" @click="prev" v-if="workListIndex.prev"><span class="prev"></span></ion-button>-->
<!--          <ion-button class="btn-back" @click="next" v-if="workListIndex.next"><span class="next"></span></ion-button>-->
<!--          <ion-button class="btn-back" @click="backReport">Back</ion-button>-->
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding ref="content">
      <ion-grid>
        <form @submit="save">
          <ion-row class="row-boxed mt-20">
            <ion-col size="12">
              <div class="title">Ref. Number: {{ workListIndex.ref_number }} - {{ workListIndex.title }}</div>
            </ion-col>
            <ion-col size="12" v-if="$store.state.user_role != 'client'">
              <div class="toolbar-add" @click="addItem">
                <img src="../assets/svg/icon-add-inverted.svg"> Add item
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="row-boxed mt-10" v-for="(item, i) in workListIndex.value" :key="'val-'+i" :id="'val-'+i">
            <ion-col size="12">
              <div class="item-block">
                <div class="item-block-header">
                  <div class="first">ITEM</div>
                  <div class="second">PROGRESS</div>
                  <div class="third">NOTES</div>
                </div>
                <div class="item-block-content">
                  <div class="first">
                    <span>
                      <!--<img @click="setIndexLightbox(i, 0)" :src="item.images[0]" v-if="item.images.length">-->
                      <!--<CoolLightBox-->
                      <!--    v-if="item.images.length"-->
                      <!--    :items="item.images"-->
                      <!--    :index="indexLightbox[i]"-->
                      <!--    @close="setIndexLightbox(i, null)">-->
                      <!--</CoolLightBox>-->

                      {{item.name}}
                    </span>
                  </div>
                  <div class="light-wrapper second">
                    {{item.progress}}
                  </div>
                  <div class="third" v-if="item.notes.at(-1)">
                    <span>{{item.notes.at(-1).desc}}</span>
                  </div>
                </div>

                <div class="item-block-btns">
                  <ion-button v-if="$store.state.user_role != 'client'" type="button" @click="() => deleteIndex(i)">Delete</ion-button>
                  <ion-button v-if="$store.state.user_role != 'client'" type="button" color="dark" @click="() => editIndex(i)">Edit</ion-button>
                  <ion-button v-if="$store.state.user_role == 'client'" type="button" color="dark">Details</ion-button>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <ion-row class="row-boxed" v-if="$store.state.user_role != 'client'">
            <ion-col size="12" class="text-right">
              <ion-button type="submit">SAVE</ion-button>
            </ion-col>
          </ion-row>

          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "CompileWorklist",
  data: function() {
    return {
      workListIndex: { value: [] },
      loader: true,
      indexLightbox: [],
      indexArray: this.$route.params.index,
      indexCopy: {},
    }
  },
  methods: {
    deleteIndex: function(index){
      return this.$ionic.alertController
        .create({
          header: 'Delete item',
          message: 'Are you sure to delete this item?',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel'
            },
            {
              text: 'Confirm',
              handler: () => {
                this.workListIndex.value.splice(index, 1);
              },
            },
          ],
        })
        .then(a => a.present())
    },
    editIndex: async function(index) {
      this.save(false, () => this.$router.push({name: 'compile-worklist-index', params: { id: this.workListIndex.id, index: index } }) )
    },
    setIndexLightbox: function(index, value){
      Vue.set(this.indexLightbox, index, value)
    },
    addItem() {
      let obj = {
        name: '',
        progress: 0,
        notes: [],
        images: [],
      }
      Vue.set(this.workListIndex.value, this.workListIndex.value.length, obj)
    },
    save: async function(ev, callback) {
      if(ev) {
        ev.preventDefault();
      }
      this.loader = true
      await axios.post(this.apiUrl + '/api/v1/save-worklist-index', { api_token: this.$store.state.api_token, index: this.workListIndex })
        .then(async () => {
          if (callback) {
            callback()
          } else {
            const toast = await this.$ionic.toastController.create({
              message: 'Index saved succesfully',
              color: 'success',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
            this.loader = false;
          }
        })
    },
    // backWorklist: async function(){
    backWorklist: function(){
      // await this.save(null)
      this.$router.push('/worklist/report/details/' + this.workListIndex.report_id);
    },
    getIndex: function(){
      axios.post(this.apiUrl + '/api/v1/get-worklist-index', { api_token: this.$store.state.api_token, id: this.$route.params.id })
          .then((response) => {
            let res = response.data
            if(res.data) {
              this.workListIndex = res.data
              Vue.set(this.workListIndex, 'value', this.workListIndex.value ? this.workListIndex.value : [])
              // this.workListIndex.value = this.workListIndex.value ? this.workListIndex.value : []
              // console.log(this.workListIndex)
              // let a = 0
              // while (a < this.workListIndex.value.length) {
              //   this.setIndexLightbox(a, null)
              //   a++
              // }
            }
            this.loader = false;

            if(this.$route.params.scroll) {
              setTimeout(() => {
                let toolbar = document.querySelector('ion-toolbar');
                let elem = document.getElementById('val-' + this.$route.params.scroll);
                let scroll = elem.offsetTop - toolbar.offsetHeight
                this.$refs['content'].scrollToPoint(0, scroll);
              }, 100);
            }
          })
    }
  },
  mounted: function() {
    this.getIndex()
  }
}
</script>

<style scoped>
.item-block-content-img {
  padding-left: 80px;
  min-height: 130px;
  position: relative;
}
.item-block-content-img img {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 70px;
  height: auto;
}
</style>